import { useContext } from "react";
import { AlertContext } from "../providers";

/**
 * Hook that returns the alert context value
 * 
 * @returns The alert context
 */
const useAlert = () => {
  const alertContext = useContext(AlertContext);

  if (!alertContext) {
    throw new Error("useAlert must be used within an AlertProvider");
  }
  return alertContext;
};

export default useAlert;
